import { RouteLocationNormalizedLoaded } from "vue-router";

const NastavitveProfila = ()  => import("@views/app/settings/settings-profile.vue");
const Nastavitve = () => import("@/app/views/app/settings/settings.vue");
const OsebniPodatki = () => import("@/app/views/app/settings/personal-data.vue");
const KontaktniPodatki = () => import("@/app/views/app/settings/contact-data.vue");
const PodatkiOZaposlitvi = () => import("@/app/views/app/settings/employment-data.vue");
const OsebnaIdentifikacija = () => import("@/app/views/app/settings/personal-identification.vue");
const Dokumentacija = () => import("@/app/views/app/settings/documentation.vue");
const FinancniPodatki = () => import("@/app/views/app/settings/financial-data.vue");
const ZakljucekSuccess = () => import("@/app/views/app/settings/end-success.vue");
const ZakljucekError = () => import("@/app/views/app/settings/end-fail.vue");
const PredkorakPredodobritev = () => import("@/app/views/app/settings/pre-approval-pre-step.vue");

export const nastavitveRoutes = [
    {
        component: NastavitveProfila,
        name: "nastavitev_profila",
        path: "nastavitve/profil"
    },
    {
        component: PredkorakPredodobritev,
        name: "predkorak_predodobritev",
        path: "predodobritev/zacetek",
        props: true
    },
    {
        component: Nastavitve,
        name: "nastavitev_stranka",
        path: "nastavitve/:flowType?",
        redirect: { name: "osebni_podatki" },
        props: true,
        beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
            if(from.name == undefined){
                return { name: "dashboard_dashboard" };
            }
            else{
                window.onbeforeunload = () => {
                    return confirm();
                }
            }
        },
        children: [
            {
                component: OsebniPodatki,
                name: "osebni_podatki",
                path: "osebni-podatki",
                props: true
            },
            {
                component: KontaktniPodatki,
                name: "kontaktni_podatki",
                path: "kontaktni-podatki",
                props: true
            },
            {
                component: PodatkiOZaposlitvi,
                name: "podatki_zaposlitev",
                path: "podatki-zaposlitev",
                props: true
            },
            {
                component: FinancniPodatki,
                name: "financni_podatki",
                path: "financni-podatki",
                props: true
            },
            {
                component: OsebnaIdentifikacija,
                name: "osebna_identifikacija",
                path: "osebna-identifikacija",
                props: true
            },
            {
                component: Dokumentacija,
                name: "dokumentacija",
                path: "dokumentacija"
            },
            {
                component: ZakljucekSuccess,
                name: "zakljucekSuccess",
                path: ""
            },
            {
                component: ZakljucekError,
                name: "zakljucekError",
                path: "napaka"
            }
        ]
    },
];